import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Select, Skeleton } from 'antd';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import TranslatedText from '../../TranslatedText';
import { getPoolHashrateChartData, isLoadingStatsPool } from '../../../redux/selectors/stats';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { calculateTicks } from './charts';
import {hashrateToString, hashrateValue, hashrateUnit} from '../../../services/hashrate';

const defaultState = {
  chartTimespanHours: 24,
  tickXFormat: 'LT',
};

class PoolHashrateChart extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = defaultState;
    this.updateTimespan = this.updateTimespan.bind(this);
  }

  updateTimespan(value) {
    this.setState({chartTimespanHours: value, tickXFormat: value > 24 ? 'l' : 'LT'});
  }

  render() {
    const data = _.takeRight(this.props.chartData, this.state.chartTimespanHours);
    const current = _.last(data);
    const ticks = current ? calculateTicks(current.timestamp, this.state.chartTimespanHours, 6) : [];

    return (
      <Card
        id="pool-hashrate-chart"
        title={<TranslatedText transKey="dashboard.poolchart.title" />}
        extra={
          <React.Fragment>
            <span>
              <TranslatedText transKey="dashboard.filters.show" />{' '}
            </span>
            <Select defaultValue="24" onChange={this.updateTimespan}>
              <Select.Option value="12">
                <TranslatedText transKey="dashboard.filters.12hrs" />
              </Select.Option>
              <Select.Option value="24">
                <TranslatedText transKey="dashboard.filters.24hrs" />
              </Select.Option>
              <Select.Option value="168">
                <TranslatedText transKey="dashboard.filters.lastweek" />
              </Select.Option>
            </Select>
          </React.Fragment>
        }
        bordered={false}
      >
        <ResponsiveContainer width="100%" height={200}>
          {this.props.poolStatsLoading ? (
            <Skeleton active title={false} paragraph={{ rows: 1, width: '90%' }} />
          ) : (
            <AreaChart data={data} margin={{top: 10, right: 30, left: 20, bottom: 0}}>
              <defs>
                <linearGradient id="chartColor" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="30%" stopColor="#efc563" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#efc563" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeWidth="0.5" vertical={false} />
              <XAxis
                dataKey="timestamp"
                domain={['dataMin', 'dataMax']}
                name="Time"
                tickFormatter={timestamp => moment.unix(timestamp).format(this.state.tickXFormat)}
                type="number"
                axisLine={false}
                tickLine={false}
                ticks={ticks}
              />
              <YAxis axisLine={false} tickLine={false} tickFormatter={value => hashrateValue(value) + hashrateUnit(value)}/>
              <Tooltip
                formatter={value => [hashrateToString(value), 'Pool Hashrate:']}
                labelFormatter={label => moment.unix(label).format('L LT')}
              />
              <Area strokeWidth={4} type="monotone" dataKey="hashrate" stroke="#efc563" fill="url(#chartColor)" />
            </AreaChart>
          )}
        </ResponsiveContainer>
      </Card>
    );
  }
}
PoolHashrateChart.propTypes = {
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      timestamp: PropTypes.number,
      hashrate: PropTypes.number,
    })
  ),
  poolStatsLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  chartData: getPoolHashrateChartData(state),
  poolStatsLoading: isLoadingStatsPool(state),
});

export default connect(mapStateToProps)(withTranslation()(React.memo(PoolHashrateChart)));



// WEBPACK FOOTER //
// /src/components/pages/dashboard/PoolHashrateChart.jsx